/** Matches polaris-service TokenEstimator: ceil(length / 4). */
export function formatAssistTokenUsage(used: number, available: number): string {
    const formatCount = (value: number): string =>
        Math.max(0, Math.floor(Number.isFinite(value) ? value : 0)).toLocaleString("en-US");
    return `Token usage: ${formatCount(used)} used / ${formatCount(available)} available`;
}

export function estimateTokens(text: string | null | undefined): number {
    if (!text) {
        return 0;
    }
    return Math.floor((text.length + 3) / 4);
}
